import MultiForm from '@admin/components/multiform'
import CanvaImport from './canva_import'
import PropTypes from 'prop-types'
import Library from './library'
import Details from './details'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Design)',
      action: '/api/admin/truevail/agency/designs',
      method: 'POST',
      getSteps: this._getSteps,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps(formdata) {
    return [
      { label: 't(Canva)', component: CanvaImport },
      { label: 't(Details)', component: Details },
      { label: 't(Library)', component: Library }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(design) {
    this.context.router.push(`/admin/truevail/agency/designs/${design.id}`)
    this.context.modal.close()
  }

}

export default New
